document.addEventListener('DOMContentLoaded', function () {
  const initProductTabs = () => {
    const sections = document.querySelectorAll('.pts-wrap');

    sections.forEach((section) => {
      const tabs = section.querySelectorAll('.pts-tab');
      const accordionTriggers = section.querySelectorAll('.pts-accordion-trigger');
      const panels = section.querySelectorAll('.pts-panel');
      const accordionItems = section.querySelectorAll('.pts-accordion-item');

      // 1. Desktop Tab Click Logic
      tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
          const targetId = this.getAttribute('data-tab');

          // Reset all tabs
          tabs.forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });

          // Activate clicked tab
          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');

          // Update Panels & Accordion Triggers
          panels.forEach((panel) => {
            if (panel.id === `panel-${targetId}`) {
              panel.classList.add('is-active');
            } else {
              panel.classList.remove('is-active');
            }
          });

          accordionTriggers.forEach((trigger) => {
            const isTarget = trigger.getAttribute('aria-controls') === `panel-${targetId}`;
            trigger.classList.toggle('is-active', isTarget);
            trigger.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
          });

          accordionItems.forEach((item) => {
            const isTarget = item.getAttribute('data-block-id') === targetId;
            item.classList.toggle('is-active', isTarget);
          });
        });
      });

      // 2. Mobile Accordions Click Logic
      accordionTriggers.forEach((trigger) => {
        trigger.addEventListener('click', function () {
          const item = this.closest('.pts-accordion-item');
          const panel = item.querySelector('.pts-panel');
          const targetId = item.getAttribute('data-block-id');
          const isOpen = this.classList.contains('is-active');

          // Close all accordion items
          accordionTriggers.forEach((trig) => {
            trig.classList.remove('is-active');
            trig.setAttribute('aria-expanded', 'false');
          });

          accordionItems.forEach((accItem) => {
            accItem.classList.remove('is-active');
          });

          panels.forEach((p) => {
            p.classList.remove('is-active');
          });

          // Toggle clicked accordion
          if (!isOpen) {
            this.classList.add('is-active');
            this.setAttribute('aria-expanded', 'true');
            item.classList.add('is-active');
            panel.classList.add('is-active');

            // Sync Desktop Tab active state as well
            tabs.forEach((tab) => {
              const isTarget = tab.getAttribute('data-tab') === targetId;
              tab.classList.toggle('is-active', isTarget);
              tab.setAttribute('aria-selected', isTarget ? 'true' : 'false');
            });
          }
        });
      });
    });
  };

  initProductTabs();
});